// customMarkers.js
import { IconFactory } from "./iconFactory";

export class CustomMarkers {
  constructor(map, iconPositions) {
    this.map = map;
    this.iconPositions = iconPositions;
    this.markers = new Map(); // id -> { marker, type }
    this.visibleTypes = {
      event1: true,
      event2: true,
      event3: true,
      event4: true,
      event5: true,
      event6: true,
    };
  }

  // Helper function to format time
  formatTime(seconds, timeframe) {
    const isDay = timeframe === "11AM";
    const baseHour = isDay ? 11 : 9;
    const baseMinute = isDay ? 0 : 30;
    
    // Calculate total seconds from base time
    const totalSeconds = baseHour * 3600 + baseMinute * 60 + seconds;
    
    // Calculate hours, minutes, seconds
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const secs = Math.floor(totalSeconds % 60);
    
    // Format with leading zeros and AM/PM
    const ampm = isDay ? 'AM' : 'PM';
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')} ${ampm}`;
  }

  addMarker(id, latLng, type, options = {}) {
    if (!this.map) return;

    // Remove existing marker if it exists
    if (this.markers.has(id)) {
      this.markers.get(id).marker.remove();
    }

    try {
      const marker = IconFactory.createMarker(latLng, type, options);
      this.markers.set(id, { marker, type });

      // Only add to map if the type is visible
      if (this.visibleTypes[type]) {
        marker.addTo(this.map);
      }

      if (options.popup) {
        // Check if event data is included
        if (options.eventData) {
          // Log the event data to verify it's correct
          console.log(`Creating popup for ${id} with event data:`, options.eventData);
          
          // Create HTML content with event jump button
          const popupContent = `
            <div class="custom-popup">
              <div class="popup-text">${options.popup}</div>
              ${options.popupImage ? `
                <div class="popup-image">
                  <img src="${options.popupImage}" alt="${options.popup}" />
                </div>
              ` : ''}
              <div class="popup-actions">
                <button class="map-event-link" 
                  data-robot-id="${options.eventData.robotId}" 
                  data-event-id="${options.eventData.eventId}" 
                  data-start-time="${options.eventData.startTime}"
                  data-frame-start="${options.eventData.frameStart || ''}">
                  Check Details ▶
                </button>
              </div>
              ${options.eventData.frameStart ? `
                <div class="popup-metadata">
                  <small>Robot ${options.eventData.robotId} | ${this.formatTime(options.eventData.startTime, options.eventData.timeframe)}</small>
                </div>
              ` : ''}
            </div>
          `;

          // Bind popup with custom options
          marker.bindPopup(popupContent, {
            maxWidth: 300,
            className: "custom-popup-container",
          });
        } else {
          // Basic popup without event data
          if (options.popupImage) {
            // Create HTML content with image
            const popupContent = `
              <div class="custom-popup">
                <div class="popup-text">${options.popup}</div>
                <div class="popup-image">
                  <img src="${options.popupImage}" alt="${options.popup}" />
                </div>
              </div>
            `;

            // Bind popup with custom options
            marker.bindPopup(popupContent, {
              maxWidth: 300,
              className: "custom-popup-container",
            });
          } else {
            // Simple text popup
            marker.bindPopup(options.popup);
          }
        }
      }

      return marker;
    } catch (error) {
      console.error(`Error creating marker for id ${id}:`, error);
    }
  }

  addMarkers(markersConfig) {
    this.clear(); // Clear existing markers first
    this.iconPositions = markersConfig;
    markersConfig.forEach((config) => {
      this.addMarker(config.id, config.position, config.type, {
        popup: config.popup,
        popupImage: config.popupImage, // 添加图片路径参数
        eventData: config.eventData // 添加事件数据
      });
    });
  }
  
  removeMarker(id) {
    const markerData = this.markers.get(id);
    if (markerData) {
      markerData.marker.remove();
      this.markers.delete(id);
    }
  }

  // 修改此方法以支持指定可见性
  toggleTypeVisibility(type, isVisible) {
    // 如果提供了isVisible参数，使用它；否则切换当前状态
    this.visibleTypes[type] = isVisible !== undefined ? isVisible : !this.visibleTypes[type];

    // Get all markers of this type
    const typeMarkers = Array.from(this.markers.entries()).filter(
      ([_, data]) => data.type === type
    );

    // Batch remove/add markers
    typeMarkers.forEach(([_, data]) => {
      if (this.visibleTypes[type]) {
        if (!this.map.hasLayer(data.marker)) {
          data.marker.addTo(this.map);
        }
      } else {
        data.marker.remove();
      }
    });
  }

  clear() {
    this.markers.forEach(({ marker }) => marker.remove());
    this.markers.clear();
  }

  updateRouteIcons(routeIcons, visible) {
    routeIcons.forEach((icon) => {
      const markerData = this.markers.get(icon.id);
      if (markerData && this.visibleTypes[markerData.type]) {
        if (visible) {
          markerData.marker.addTo(this.map);
        } else {
          markerData.marker.remove();
        }
      }
    });
  }

  isTypeVisible(type) {
    return this.visibleTypes[type] || false;
  }
}